import { MessageFromCometContent } from 'reducers/messenger/ChatMessengerState'

/**
 * https://youtrack.mamba.ru/issue/M-5943
 * Не можем доверять комете на тему возможности отправки фото.
 * Поэтому поле `isPrivatePhotoEnabled` удаляем.
 * @param message
 */
export const fixBackendMessage = (message: MessageFromCometContent) => {
  delete message.contact.isPrivatePhotoEnabled
}
